(function() {
  var barEl = document.querySelector('[data-cart-shipping-bar]');
  var THRESHOLD = barEl ? parseInt(barEl.dataset.threshold) || 12500 : 12500;
  var messageTemplate = (barEl && barEl.dataset.message) || 'Add __AMOUNT__ more and ship free';

  function buildBar(bar, total) {
    var gap = THRESHOLD - total;
    var pct = Math.min(Math.round((total / THRESHOLD) * 100), 100);

    if (total >= THRESHOLD) {
      bar.classList.add('cart__shipping-bar--unlocked');
      bar.innerHTML = '<p class="cart__shipping-bar__message">Your order qualifies for free shipping</p>';
    } else {
      bar.classList.remove('cart__shipping-bar--unlocked');
      bar.innerHTML =
        '<div class="cart__shipping-bar__top">' +
          '<span class="cart__shipping-bar__message">' + messageTemplate.replace('__AMOUNT__', '$' + (gap / 100).toFixed(2).replace(/\.00$/, '')) + '</span>' +
        '</div>' +
        '<div class="cart__shipping-bar__track">' +
          '<div class="cart__shipping-bar__fill" style="width:' + pct + '%"></div>' +
        '</div>';
    }
  }

  function updateBar() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var bar = document.querySelector('[data-cart-shipping-bar]');
        if (bar) {
          THRESHOLD = parseInt(bar.dataset.threshold) || THRESHOLD;
          messageTemplate = bar.dataset.message || messageTemplate;
          buildBar(bar, cart.total_price);
          return;
        }
        var drawerBody = document.querySelector('.drawer__body');
        if (!drawerBody) return;
        var newBar = document.createElement('div');
        newBar.className = 'cart__shipping-bar';
        newBar.setAttribute('data-cart-shipping-bar', '');
        drawerBody.insertBefore(newBar, drawerBody.firstChild);
        buildBar(newBar, cart.total_price);
      })
      .catch(function(e) { console.log('cart error', e); });
  }

  document.addEventListener('DOMContentLoaded', updateBar);
  document.addEventListener('theme:cart:change', updateBar);
  document.addEventListener('cart:updated', updateBar);

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.addedNodes.length) updateBar();
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    var drawerBody = document.querySelector('.drawer__body');
    if (drawerBody) {
      observer.observe(drawerBody, { childList: true });
    }
  });

})();